export default "__VITE_ASSET__BFLKR7_x__"